<template>
  <div class="owl-carousel owl-theme">
    <slot></slot>
  </div>
</template>

<style lang="stylus" scoped></style>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        loop: false,
        margin: 10,
        nav: true,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 3,
          },
          1200: {
            items: 5,
          },
        },
      }),
    },
  },
  mounted() {
    this.$nextTick(() => {
      $(this.$el).owlCarousel(this.options)
    })
  },
}
</script>
